module.exports = __webpack_public_path__ + "img/gift-m.7e4c4603.png";